import React, {useState} from 'react';
import SelectInput from "./SelectInput";
import {Button, Input, Modal, Select, Tooltip} from "antd";
import {PlusOutlined, DeleteOutlined} from '@ant-design/icons';
import {NavLink} from "react-router-dom";
const Sfr = () => {
    const handleChange = (value) => {
        console.log(value); // { value: "lucy", key: "lucy", label: "Lucy (101)" }
    };

    const [open, setOpen] = useState(false);
    const showModal = () => {
        setOpen(true);
    };
    const handleOk = () => {
        setOpen(false);
    };
    const handleCancel = () => {
        setOpen(false);
    };

    return (
        <div>
            <h3 className="text-center text-uppercase mt-2 mb-4">Suvdan foydalanish rejasi</h3>
            <div className="row">
                <div className="col-md-2">
                    <Select
                        labelInValue
                        defaultValue={{
                            value: 'Xisobot turi',
                            label: 'Xisobot turi',
                        }}
                        style={{
                            width: '100%',
                        }}
                        onChange={handleChange}
                        options={[
                            {
                                value: '1',
                                label: 'Fao - 56 bo\'yicha',
                            },
                            {
                                value: '2',
                                label: 'Gidromodul bo\'yicha',
                            },
                        ]}
                    />
                    <Select
                        className="mt-3"
                        labelInValue
                        defaultValue={{
                            value: 'Yangi xisobot turi',
                            label: 'Yangi xisobot turi',
                        }}
                        style={{
                            width: '100%',
                        }}
                        onChange={handleChange}
                        options={[
                            {
                                value: '1',
                                label: 'ITXB uchun xisobot',
                            },
                            {
                                value: '2',
                                label: 'ITB uchun xisobot',
                            },
                            {
                                value: '3',
                                label: 'TIB uchun xisobot',
                            },
                            {
                                value: '4',
                                label: 'SIU uchun xisobot',
                            },
                            {
                                value: '5',
                                label: 'Fermer uchun xisobot',
                            },
                        ]}
                    />
                </div>
                <div className="col-md-10">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="mb-3">
                                <Input placeholder="Ism sharfingizni kiriting" />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="mb-3">
                                <Select
                                    labelInValue
                                    defaultValue={{
                                        value: 'ITXBni tanlang',
                                        label: 'ITXBni tanlang',
                                    }}
                                    style={{
                                        width: '100%',
                                    }}
                                    onChange={handleChange}
                                    options={[
                                        {
                                            value: '1',
                                            label: 'Amu-Qashqadaryo ITXB (Qashqadaryo)',
                                        },
                                        {
                                            value: '2',
                                            label: 'Amu-Buxoro ITXB (Buxoro)',
                                        },
                                        {
                                            value: '3',
                                            label: 'Amu-Surxon ITXB (Surxondaryo)',
                                        },
                                        {
                                            value: '4',
                                            label: 'Amudaryo Chap qirg\'oq (Xorazm)',
                                        },
                                    ]}
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="mb-3">
                                <Select
                                    labelInValue
                                    defaultValue={{
                                        value: 'ITBni tanlang',
                                        label: 'ITBni tanlang',
                                    }}
                                    style={{
                                        width: '100%',
                                    }}
                                    onChange={handleChange}
                                    options={[
                                        {
                                            value: '1',
                                            label: 'ITB 1',
                                        },
                                        {
                                            value: '2',
                                            label: 'ITB 2',
                                        },
                                        {
                                            value: '3',
                                            label: 'ITB 3',
                                        },
                                        {
                                            value: '4',
                                            label: 'ITB 4',
                                        },
                                    ]}
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="mb-3">
                                <Select
                                    labelInValue
                                    defaultValue={{
                                        value: 'TIBni tanlang',
                                        label: 'TIBni tanlang',
                                    }}
                                    style={{
                                        width: '100%',
                                    }}
                                    onChange={handleChange}
                                    options={[
                                        {
                                            value: '1',
                                            label: 'TIB 1',
                                        },
                                        {
                                            value: '2',
                                            label: 'TIB 2',
                                        },
                                        {
                                            value: '3',
                                            label: 'TIB 3',
                                        },
                                        {
                                            value: '4',
                                            label: 'TIB 4',
                                        },
                                    ]}
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="mb-3">
                                <Select
                                    labelInValue
                                    defaultValue={{
                                        value: 'SIUni tanlang',
                                        label: 'SIUni tanlang',
                                    }}
                                    style={{
                                        width: '100%',
                                    }}
                                    onChange={handleChange}
                                    options={[
                                        {
                                            value: '1',
                                            label: 'SIU 1',
                                        },
                                        {
                                            value: '2',
                                            label: 'SIU 2',
                                        },
                                        {
                                            value: '3',
                                            label: 'SIU 3',
                                        },
                                        {
                                            value: '4',
                                            label: 'SIU 4',
                                        },
                                    ]}
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="mb-3">
                                <Input placeholder="Fermer xo'jaligi nomi" />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="mb-3">
                                <Select
                                    labelInValue
                                    defaultValue={{
                                        value: 'Sug\'orish turi',
                                        label: 'Sug\'orish turi',
                                    }}
                                    style={{
                                        width: '100%',
                                    }}
                                    onChange={handleChange}
                                    options={[
                                        {
                                            value: '1',
                                            label: 'Vegetatsiya',
                                        },
                                        {
                                            value: '2',
                                            label: 'Novegetatsiya',
                                        },
                                    ]}
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="mb-3">
                                <SelectInput />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="mb-3">
                                <button type="button" style={{padding: "2px 10px"}} className="fw-bold btn btn-warning me-1" onClick={showModal}>Gidramodulni o'rgartirish </button>
                                <NavLink to="xisobot" style={{padding: "2px 10px"}} className="fw-bold btn btn-success">Yangi xisobot</NavLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                title="Gidramodullar ro'yxati"
                open={open}
                onOk={handleOk}
                onCancel={handleCancel}
                width={1000}
                cancelText="Yopish"
            >
                <div className="row">
                    <div className="col-md-9">
                        <table className="table table-bordered text-center">
                            <thead className="align-middle bg-info">
                            <tr>
                                <th scope="col" rowSpan={2}>N</th>
                                <th style={{width: "300px"}} scope="col" rowSpan={2}>Ekin turi</th>
                                <th scope="col" rowSpan={2}>Sug'orish tartibi</th>
                                <th scope="col" rowSpan={2}>Sug'orish me'yori</th>
                                <th scope="col" colSpan={2}>Sug'orish muddati</th>
                            </tr>
                            <tr>
                                <th scope="col">Boshi</th>
                                <th scope="col">Oxiri</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <th scope="row"><input type="checkbox"/></th>
                                <th scope="row">G'alla</th>
                                <td>1</td>
                                <td>1500</td>
                                <td>01.05.2023</td>
                                <td>10.05.2023</td>
                            </tr>
                            </tbody>
                        </table>
                        <div className="row">
                            <div className="col-md-4">
                                <Select
                                    labelInValue
                                    defaultValue={{
                                        value: "0",
                                        label: 'Kuchli sho\'rlanganlik',
                                    }}
                                    style={{
                                        width: '100%',
                                    }}
                                    onChange={handleChange}
                                    options={[
                                        {
                                            value: '1',
                                            label: 'Beda',
                                        },
                                        {
                                            value: '2',
                                            label: 'G\'alla',
                                        },
                                        {
                                            value: '3',
                                            label: 'G\'o\'za',
                                        },
                                        {
                                            value: '4',
                                            label: 'Paxta',
                                        },
                                    ]}
                                />
                            </div>
                            <div className="col-md-8 add-data">
                                <Button className="me-2" type="primary" icon={<PlusOutlined />}>
                                    Sug'orish davri
                                </Button>
                                <Button type="primary" danger icon={<DeleteOutlined />}>
                                    Sug'orish davri
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <Select
                            labelInValue
                            defaultValue={{
                                value: 'Gidromodelni tanlang',
                                label: 'Gidromodelni tanlang',
                            }}
                            style={{
                                width: '100%',
                            }}
                            onChange={handleChange}
                            options={[
                                {
                                    value: '1',
                                    label: '1',
                                },
                                {
                                    value: '2',
                                    label: '2',
                                },
                                {
                                    value: '3',
                                    label: '3',
                                },
                                {
                                    value: '4',
                                    label: '4',
                                },
                            ]}
                        />
                    </div>
                </div>

            </Modal>
        </div>
    );
};

export default Sfr;